import { fetchAuthorizedJsonApi, fetchJsonApi } from './abstract';
import { getApiLanguage } from './language';
export function fetchDealByAliasOrId(apiUrl, token, dealAliasOfId) {
    return fetchJsonApi({
        apiUrl: apiUrl,
        body: undefined,
        skipHumanVerification: undefined,
        headers: token ? { Authorization: "Bearer ".concat(token) } : undefined,
        method: 'GET',
        endpoint: "v1/deals/areas/".concat(dealAliasOfId),
        query: { lang: getApiLanguage() },
        expectedStatus: 200,
        description: "Fetching deals area",
    });
}
export function claimDealOffer(apiUrl, token, offerId) {
    return fetchAuthorizedJsonApi({
        apiUrl: apiUrl,
        token: token,
        method: 'POST',
        endpoint: "v1/deals/offers/".concat(offerId, "/claim"),
        body: { _id: offerId },
        expectedStatus: 200,
        description: 'Claiming an offer',
    });
}
